import { Box, Link } from '@mui/material';
import { WsColors, WsTypography, WsTypoVariants } from 'wisestep-base';

const VendorSubscribedEmail = () => (
  <Box m={2}>
    <Box textAlign="center" p={4} bgcolor={WsColors.White} mt={2} borderRadius={2}>
      <WsTypography variant={WsTypoVariants.TITLE} bold>
        {"Great ! We'll start sending you the latest job openings shortly."}
      </WsTypography>
      <Box py={2}>
        <WsTypography variant={WsTypoVariants.SUB_TITLE}>You might also like:</WsTypography>
      </Box>
      <Box pb={2}>
        <WsTypography variant={WsTypoVariants.SUB_TITLE}>
          The Wisestep Chrome Browser Extension to help you Automate your Recruitment.
        </WsTypography>
      </Box>
      <Link href="https://wisestep.com/" fontSize="24px">
        Try Now
      </Link>
    </Box>
  </Box>
);

export default VendorSubscribedEmail;
